import { Vector3 } from 'three';
import WebGL from 'three/examples/jsm/capabilities/WebGL';

const isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
const url = new URLSearchParams(isBrowser ? window.location.search : '');

const DEBUG = url.has('debug');

const BREAKPOINTS = { tablet: 768, desktop: 1025, large: 1441 };

const CAMERA = {
  position: new Vector3(0, 0.1, 4.5),
};

const DEVICE = isBrowser
  ? {
      touch: !!(
        window.matchMedia('(pointer: coarse)').matches ||
        typeof window.ontouchstart === 'function' ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      ),
      isWebgl2: WebGL.isWebGL2Available(),
    }
  : { touch: false, isWebgl2: false };

export { DEBUG, BREAKPOINTS, CAMERA, DEVICE };
